import { forwardRef as fe, useState as y, useRef as he, useCallback as s, useMemo as xe } from "react";
import { useThemeUI as Se, Box as b, Input as we } from "theme-ui";
import { EyeSlashed24Icon as ye, Eye24Icon as be, Cross16Icon as ge } from "@material-bank/mb-icons";
import { useDerivedState as ve, mergeRefs as Ie } from "@material-bank/ds-utils";
import "../../theme/base-theme/breakpoints.js";
import "../../theme/base-theme/components/collapsible.js";
import "../../theme/base-theme/components/dialogs.js";
import "../../theme/base-theme/components/forms/forms.js";
import { inputAutofillAnimation as Ae } from "../../theme/base-theme/components/forms/input.js";
import "../../theme/base-theme/components/skeletons.js";
import "../../theme/base-theme/components/tags.js";
import "../../theme/base-theme/components/toast.js";
import "../../theme/base-theme/components/tooltips.js";
import "../../theme/base-theme/keyframes.js";
import "../../theme/base-theme/theme.js";
import { Skeleton as Ce } from "../Skeleton/Skeleton.js";
import { IconButton as E } from "../Button/IconButton/IconButton.js";
import { InputAdornment as g } from "./InputAdornment/InputAdornment.js";
import { Text as N } from "../Typography/Text.js";
import { jsx as o, jsxs as R } from "theme-ui/jsx-runtime";
const ze = fe((U, D) => {
  const {
    Component: H = we,
    value: j,
    onChange: p,
    onTextChange: q,
    defaultValue: G,
    variant: i = "filled",
    size: r = "md",
    displayInputNumberArrows: M = !1,
    disabled: n,
    loading: v = !1,
    fullWidth: Y,
    required: $,
    startAdornment: I,
    endAdornment: x,
    placeholder: J,
    placeholderBehavior: S = i === "filled" ? "disappear" : "moveUp",
    fixedPlaceholder: A,
    onFocus: d,
    onBlur: u,
    error: w,
    helperText: C,
    helperSx: K,
    helperTextSx: L,
    clearable: z,
    onClear: c,
    onClick: O,
    onContainerFocus: Q,
    onContainerBlur: X,
    sx: Z,
    containerSx: _,
    adornmentsSx: T,
    placeholderSx: ee,
    fixedPlaceholderSx: oe,
    fixedPlaceholderInputSx: te,
    type: a,
    children: ne,
    ...re
  } = U, {
    theme: t
  } = Se(), [B, F] = y(!1), [ie, se] = y(!1), [l, ae] = y(!1), [m, f] = ve({
    value: j,
    initialValue: G ?? "",
    onChange: q
  }), P = he(null), h = !!(m != null && m.toString().length), V = B || h || ie, le = (() => a === "password" && l ? "text" : a)(), W = s((e) => {
    e.preventDefault(), ae(!l);
  }, [l]), k = xe(() => {
    if (x)
      return x;
    if (a === "password")
      return /* @__PURE__ */ o(E, {
        variant: "ghost",
        icon: l ? /* @__PURE__ */ o(ye, {}) : /* @__PURE__ */ o(be, {}),
        size: "sm",
        type: "button",
        onClick: W
      });
  }, [x, a, W, l]), pe = s((e) => {
    p == null || p(e), f(e.target.value);
  }, [p, f]), de = s((e) => {
    F(!0), d == null || d(e);
  }, [d]), ue = s((e) => {
    F(!1), u == null || u(e);
  }, [u]), ce = s((e) => {
    se(e.animationName === Ae.name);
  }, []), me = s(() => {
    var e;
    (e = P.current) == null || e.focus(), c == null || c(), f("");
  }, [f, c]);
  return /* @__PURE__ */ o(Ce, {
    enabled: v,
    applyToDisabled: !0,
    asChild: !0,
    children: /* @__PURE__ */ R(b, {
      onClick: O,
      onFocus: Q,
      onBlur: X,
      sx: {
        ...t.inputWrapperSizes[r],
        ...t.inputWrapper[i],
        ...B && t.inputWrapperVariantStateStyles[i].focused,
        ...Y && {
          width: "100%"
        },
        ...h && {
          color: "primary"
        },
        ...w && t.inputWrapperVariantStateStyles[i].error,
        ...n && {
          pointerEvents: "none"
        },
        ...v && {
          ...t.inputWrapperSizes[r],
          borderBottom: i === "ghost" ? "none" : void 0
        },
        ..._
      },
      children: [I && /* @__PURE__ */ o(g, {
        disabled: n,
        inputSize: r,
        sx: T,
        children: I
      }), /* @__PURE__ */ R(b, {
        sx: {
          position: "relative",
          flexGrow: 1
        },
        children: [/* @__PURE__ */ o(N, {
          sx: {
            position: "absolute",
            left: 0,
            transition: "all",
            pointerEvents: "none",
            lineHeight: "20px",
            color: "secondaryText",
            maxWidth: "100%",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            ...t.inputPlaceholderSizes[r],
            ...n && {
              color: "disabledText"
            },
            ...$ && {
              "::after": {
                content: '"*"'
              }
            },
            ...S === "disappear" && h && {
              display: "none"
            },
            ...S === "moveUp" && (V || A) && {
              transform: "translateY(-14px)",
              fontSize: "xs",
              ...oe
            },
            ...ee
          },
          children: J
        }), ne ?? /* @__PURE__ */ o(H, {
          ref: Ie(D, P),
          ...re,
          value: m,
          onChange: pe,
          variant: i,
          onBlur: ue,
          onFocus: de,
          disabled: n,
          onAnimationStart: ce,
          type: le,
          sx: {
            lineHeight: "body",
            fontFamily: "main",
            "&:focus": {
              outline: "none",
              boxShadow: "none"
            },
            ...t.inputSizes[r],
            ...n && {
              color: "secondaryText"
            },
            ...w && {
              color: "error"
            },
            ...S === "moveUp" && (V || A) && {
              pt: 2,
              ...te
            },
            ...!M && {
              ...t.hideInputNumberArrows
            },
            ...Z
          }
        })]
      }), (z === "always" || z && h) && /* @__PURE__ */ o(g, {
        inputSize: r,
        children: /* @__PURE__ */ o(E, {
          size: "sm",
          variant: "ghost",
          icon: /* @__PURE__ */ o(ge, {}),
          onClick: me,
          disabled: n
        })
      }), k && /* @__PURE__ */ o(g, {
        inputSize: r,
        disabled: n,
        sx: T,
        children: k
      }), C && /* @__PURE__ */ o(b, {
        sx: {
          position: "absolute",
          bottom: t.spacing(-1),
          left: 0,
          width: "100%",
          ...K
        },
        children: /* @__PURE__ */ o(N, {
          sx: {
            position: "absolute",
            fontSize: "xs",
            lineHeight: "initial",
            transition: "all",
            ...n && {
              color: "disabledText"
            },
            ...w && {
              color: "error"
            },
            ...L
          },
          children: C
        })
      })]
    })
  });
});
ze.displayName = "Input";
export {
  ze as Input
};
